import React, { useEffect, useState } from "react";
import "../../doctor/components/allpages.css";
import Header from "../../../layouts/doctor/DoctorHeader";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Box,
    TablePagination,
  } from "@mui/material";
import { Link, useOutletContext } from 'react-router-dom';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import useEncryption from "../../../services/useEncryption";
import { getTransactionAPIData } from "../../../api/cardApi";

export const TransactionInfo = () => {

  const { encryptData, decryptData } = useEncryption();
  const [data, setData] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useOutletContext();
  const decryptedId = decryptData(decodeURIComponent(id));

  // Fetch paginated data from API
  useEffect(() => {
    const getTransactionData = async()=>{
      try {
        setLoading(true);
          let response = await getTransactionAPIData(decryptedId);
          const decryptedData = decryptData(response?.data?.data);
          setData(decryptedData)
          setLoading(false);
      } catch (error) {
        //   console.error("Error fetching trans data", error);
          setLoading(false);
      }
    }
    getTransactionData();
  }, []); // Re-fetch data when page or rows per page changes

    return(
      <div>
        <Header 
        pageTitle={
          <>
            Transaction Details
          </>
        } 
        />
        <div className="cardOuter">
          <div className="cardheads">
            <div className="cardTitle"></div>

          </div>
          <div className="cardcontents tableDesigned">
            <TabContext className="tabsDesigns">

              <TabPanel className="tabpanelControl">
                <div className="topsearchs">
                  <div className="d-flex align-items-center justify-content-between">
                    {/* <div className="searchBar"></div> */}
                  </div>
                  <Box>
                <TableContainer component={Paper}>
                   <Table>
                        <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>                             
                            <TableCell>LocationName</TableCell>
                            <TableCell>Payment Id</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                          {data.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={6} align="center">
                                No data found
                              </TableCell>
                            </TableRow>
                          ) : (
                            data.map((row) => (
                              <TableRow key={row._id}>
                                <TableCell>{dayjs(row.paymentCreated * 1000).format('YYYY-MM-DD')}</TableCell>
                                <TableCell>{row.providerId?.organizationName}</TableCell>
                                <TableCell>{row.payment_id}</TableCell>
                                <TableCell>{row.providerId?.email}</TableCell>
                                <TableCell>${row.amount}</TableCell>
                                <TableCell>{row.status}</TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                    </Table>
                  </TableContainer>
                 </Box>
               </div>
              </TabPanel>
            </TabContext>
          </div>
        </div>
    </div>
    )
}